module.exports = __webpack_public_path__ + "assets/img/intro-vip-a3.9ae2fc80.jpg";